<template>
  <div>
    <v-card-title>
      {{ titleText }}
    </v-card-title>

    <v-card-text>
      <v-form v-model="valid" ref="form">
        <v-container>
          <v-row>

            <!-- Общие поля для task & question -->
            <template v-if="isTask || isQuestion">
              <label class="pd-lr-10">{{ mainTextLabel }}</label>
              <v-textarea
                class="pd-lr-10"
                :rules="textRules"
                v-model="editableItemTitle"
                outlined
                required
              />

              <label class="pd-lr-10">{{ descriptionLabel }}</label>
              <v-textarea
                class="pd-lr-10"
                v-model="editableItem.description"
                outlined
                required
              />

              <!-- Блок файлов только для task -->
              <div v-if="isTask" style="padding: 0;">
                <label class="pd-lr-10" style="width: 100%">Добавьте файлы</label>

                <user-card class="user-card pd-lr-10"" style="padding: 0;">
                  <template v-slot:body>
                    <p class="file-error">{{ fileError }}</p>

                    <div class="container-tab rel" @dragover.prevent @drop.prevent>

                      <div
                        @dragover.prevent="onDragOver"
                        @dragleave.prevent="onDragLeave"
                        @drop.prevent="handleDrop"
                        :class="{ 'is-dragover': isDragOver }"
                      >
                        <span
                          v-if="filelist.length === 0"
                          class="drag-text"
                          style="padding: 0; margin-left: 100px; width: 65%; max-height: 25px"
                        >
                          Перетащите файлы для загрузки
                        </span>

                        <table>
                          <tr>
                            <td class="plus-block">
                              <label for="file" style="margin: 0;">
                                <v-icon>ti-plus</v-icon>
                                <input
                                  id="file"
                                  type="file"
                                  multiple
                                  @change="addFiles"
                                  accept=".txt,.pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                                  style="display:none;"
                                />
                              </label>
                            </td>

                            <td
                              v-for="file in filelist"
                              :key="file.name"
                              class="newFile custom-i"
                            >
                              <v-btn
                                class="close-button custom-close btn-pd"
                                variant="text"
                                @click="removeNewFile(file)"
                              >
                                <v-icon>ti-close</v-icon>
                              </v-btn>

                              <a :href="file.url" target="_blank" :title="file.name">
                                <i :class="fileIcon(file.fileExtension)"></i>
                                <span class="text-10" style="padding: 0 5px;">{{ file.name }}</span>
                              </a>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </template>
                </user-card>
              </div>

            </template>

            <!-- Поля для обычной сущности -->
            <template v-else>
              <label class="pd-lr-10 mb-0">Название элемента</label>
              <v-text-field
                v-model="editableItemTitle"
                :rules="textRules"
                maxlength="100"
                dense
                required
              />

              <label class="pd-lr-10 mb-0">Имя элемента (англ.)</label>
              <v-text-field
                v-model="editableItemPathInput"
                :rules="pathRules"
                maxlength="50"
                dense
                required
              />

              <label class="pd-lr-10 mb-0">Описание</label>
              <v-textarea v-model="editableItem.description" />
            </template>

            <!-- ТИП -->
            <span>Тип: <b>{{ editableItem.type }}</b></span>

            <!-- Общие поля для веса -->
            <div class="slider-weight">
              <label>
                Значимость: <b>{{ editableItem.weight }}</b>
              </label>
              <input
                type="range"
                min="0.1"
                max="1"
                step="0.1"
                v-model="editableItem.weight"
                class="slider"
                id="myRange"
              />
            </div>

            <!-- Кнопка сохранения -->
            <div class="text-center mt-4">
              <v-btn class="btnSave primary-btn" @click="handleSave">
                Сохранить
              </v-btn>
            </div>

          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </div>
</template>

<script>
import UserCard from "@/pages/UserProfileTeamplate/UserCard.vue";

import GlobalRequest from "@/plugins/globalRequest";
import GlobalMethods from "@/plugins/globalMethods";

export default {

  components: { UserCard },

  props: {
    entityType: String,
    entityKey: String,
    skillId: Number,
    data: { type: Object, required: true }
  },

  data() {
    return {
      valid: false,
      editableItem: {},
      editableItemTitle: "",
      editableItemPathInput: "",
      filelist: [],
      fileError: "",

      textRules: [v => !!v || "Поле обязательно"],
      pathRules: [
        v => !!v || "Поле обязательно",
        v => /^[-_A-Za-z0-9]+$/.test(v) || "Недопустимые символы"
      ],

      isDragOver: false,
      rootUrl: process.env.VUE_APP_FILE_URL
    };
  },

  computed: {
    isTask() {
      return this.editableItem.type === "task";
    },
    isQuestion() {
      return this.editableItem.type === "question";
    },
    titleText() {
      if (this.isTask) return "Редактирование задания";
      if (this.isQuestion) return "Редактирование вопроса";
      return "Редактирование сущности";
    },
    mainTextLabel() {
      return this.isTask ? "Текст задания" : "Текст вопроса";
    },
    descriptionLabel() {
      return this.isTask ? "Описание задания" : "Описание вопроса";
    }
  },

  watch: {
    editableItemTitle() {
      const translated = GlobalMethods.textTranslate(this.editableItemTitle);

      if (!this.isTask && !this.isQuestion && !this.editableItemPathInput)
        this.editableItemPathInput = translated;
    }
  },

  mounted() {
    this.editableItem = JSON.parse(JSON.stringify(this.data));
    this.editableItemTitle = this.editableItem.title || "";
    this.editableItemPathInput = this.editableItem.path || "";

    console.log(this.editableItem)
  },

  methods: {
    // Иконки
    fileIcon(ext) {
      const map = {
        doc: "fa fa-file-word-o",
        docx: "fa fa-file-word-o",
        xls: "fa fa-file-excel-o",
        xlsx: "fa fa-file-excel-o",
        png: "fa fa-file-image-o",
        jpg: "fa fa-file-image-o",
        jpeg: "fa fa-file-image-o",
        pdf: "fa fa-file-pdf-o"
      };
      return map[ext] || "fa fa-file-o";
    },

    // Сохранение
    async handleSave() {
      const ok = await this.$refs.form.validate();
      if (!ok) return;

      this.editableItem.key = this.entityKey;
      
      this.editableItem.title = this.editableItemTitle;

      if (!this.isTask && !this.isQuestion) {
        this.editableItem.path = this.editableItemPathInput;
      }

      this.editableItem.formdata = this.buildFormData();
      this.$emit("saveEditedEntity", this.editableItem);
    },

    // Работа с файлами
    addFiles(e) {
      this.fileError = "";
      const files = Array.from(e.target.files);
      this.filelist = this.filelist.concat(files);
    },

    removeNewFile(file) {
      this.filelist = this.filelist.filter(f => f.name !== file.name);
    },

    buildFormData() {
      const fd = new FormData();
      this.filelist.forEach(file => {
        fd.append("files[]", file);
      });
      return fd;
    },

    onDragOver() { this.isDragOver = true; },
    onDragLeave() { this.isDragOver = false; },

    handleDrop(e) {
      this.isDragOver = false;
      this.fileError = "";
      const dropped = Array.from(e.dataTransfer.files);

      dropped.forEach(file => {
        const exists = this.filelist.some(f => f.name === file.name);
        if (exists) return;

        const ext = file.name.split(".").pop().toLowerCase();
        const allowed = ["txt", "pdf", "doc", "docx", "xls", "xlsx", "png", "jpg", "jpeg"];
        if (allowed.indexOf(ext) === -1) {
          this.fileError = "Запрещённый формат файла";
          return;
        }

        this.filelist.push(file);
      });
    },
  }
};
</script>

<style scoped>
  /* .small-text {
    font-size: 12px;
    padding: 0 5px;
  }
  .close-button {
    padding: 0;
  }
  .slider-weight {
    margin: 15px 0;
  }
  .drag-text {
    opacity: 0.6;
    font-size: 12px;
  }
  .file-error {
    color: red;
  } */

  .small-text {
    padding: 0 5px;
    font-size: 12px;
  }
  .btn-pd span {
    padding: 0 !important;
  }
  .text-10 {
    font-size: 10px !important;
    max-height: 27px !important;
  }
  .newFile .v-btn__content {
    padding: 0 !important;
  }
  .close-button {
    background-color: transparent !important;
  }
  .close-button .v-icon {
    font-size: 10px;
    display: flex;
    align-items: center;
  }
</style>
